// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Styles
import './FloatingButtonContainer.scss';

const FloatingButtonContainer = (props) => (
    <div className="FloatingButtonContainer">
        <div className="floating-area">{props.children}</div>
    </div>
);

FloatingButtonContainer.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default FloatingButtonContainer;
